import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Capsules = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.4 82.29">
  <G fill={color}>
    <Path d="M12.73,49.59c-5.11,3.56-9.08,8.2-11.15,13.06-2.28,5.34-2.08,10.37.56,14.16,2.47,3.55,6.7,5.48,11.99,5.48.36,0,.73,0,1.1-.03,5.28-.26,11.01-2.36,16.12-5.91,11.16-7.76,15.81-19.72,10.6-27.22-5.22-7.5-18.05-7.29-29.21.47ZM18.37,62.75c-1.98,1.7-3.52,3.57-4.21,5.12-.5,1.12-1.59,1.78-2.74,1.78-.41,0-.82-.08-1.22-.26-1.51-.68-2.19-2.45-1.52-3.96,1.06-2.37,3.11-4.94,5.79-7.23,1.26-1.08,3.15-.93,4.23.32,1.08,1.26.93,3.15-.32,4.23ZM29.07,57.53c-.36.02-.75.07-1.17.16-.51.1-1.06.25-1.62.44-.32.11-.64.16-.95.16-1.26,0-2.43-.79-2.85-2.05-.52-1.57.32-3.27,1.9-3.8.8-.27,1.59-.48,2.35-.63.69-.14,1.36-.23,2-.26,1.65-.09,3.07,1.17,3.17,2.83.09,1.65-1.17,3.07-2.83,3.16Z"/>
    <Path d="M39.8,3.7C27.66-2.41,14.93-.79,10.82,7.37c-4.1,8.16,2.2,19.34,14.34,25.45,4.96,2.49,10.01,3.7,14.53,3.7,6.56,0,12.01-2.54,14.44-7.37,4.1-8.16-2.2-19.34-14.34-25.45ZM34.79,13.2c-.46,1.2-1.6,1.93-2.8,1.93-.36,0-.72-.06-1.07-.2-2.44-.93-4.81-1.39-6.51-1.26-1.65.12-3.09-1.11-3.22-2.76-.13-1.65,1.11-3.09,2.76-3.22,2.59-.2,5.83.38,9.11,1.64,1.55.59,2.32,2.33,1.73,3.87ZM44.75,22.82c-.49.3-1.04.45-1.58.45-1,0-1.99-.5-2.55-1.42-.19-.31-.42-.63-.7-.96-.33-.4-.72-.81-1.16-1.22-1.21-1.13-1.27-3.03-.14-4.24,1.13-1.21,3.03-1.27,4.24-.14.61.57,1.18,1.17,1.67,1.76.45.55.85,1.1,1.19,1.64.87,1.41.44,3.26-.97,4.13Z"/>
  </G>
</Svg>
);
};

export default Capsules;
